<template>
  <div>
    <v-row>
      <v-col cols="12">
        <strong class="mr-1">{{ $t('ITEM.DATE_ENTERED') }}:</strong>
        <span>{{ form.created_at | dateFormat }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <customer-select
          v-if="isCreate"
          v-model="form.person_id"
          item-text="name"
          item-value="id"
          :loading="loading"
          :mass-market="resource.mass_market"
          :building-complex-id="resource.building_complex_id"
          :customer="customer"
          :rules="getRulesByName('person_id')"
          :label="`${$t('BOOKING.RESERVATIONS.CUSTOMER')} *`"
          @change="updateValue('person_id', $event)"
        />
        <v-text-field
          v-if="!isCreate"
          :value="form.person.full_name"
          :label="`${$t('BOOKING.RESERVATIONS.CUSTOMER')} *`"
          readonly
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col col="12">
        <v-text-field
          v-model="form.number_of_visitors"
          name="number_of_visitors"
          :readonly="readonly"
          :rules="getRulesByName('number_of_visitors')"
          :error-messages="errors.number_of_visitors"
          type="number"
          disabled
          :max="resource.capacity"
          prepend-inner-icon="mdi-account-multiple-outline"
          @input="updateValue('number_of_visitors', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <booking-resource-sheet
          class="pa-4"
          :resource="resource"
          rounded
          small
        />
      </v-col>
    </v-row>
    <component
      :is="getComponentByType(resource.type_id)"
      v-if="resource.type_id"
      v-model="form"
      :readonly="readonly"
      :errors="errors"
      :step="resource.step || ''"
      @input="emitter"
      @update-prop="updateProp(...arguments)"
    />

    <v-row>
      <v-col v-if="form.access_key" cols="12">
        <v-text-field
          v-model="form.access_key"
          name="access_key"
          :label="$t('BOOKING.RESERVATIONS.ACCESS_KEY')"
          :error-messages="errors.access_key"
          readonly
          @input="updateValue('access_key', $event)"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="form.info"
          name="info"
          :rows="4"
          :counter="400"
          :label="$t('ITEM.ADDITIONAL_INFO')"
          :readonly="readonly"
          :rules="getRulesByName('info')"
          :error-messages="errors.info"
          outlined
          @input="updateValue('info', $event)"
        ></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { dateFormat } from '@/modules/_global/filters';
import { DAY, HOUR, MINUTE } from '@/modules/booking_resources/common/types';
import {
  isNumeric,
  maxLength,
  notEmpty
} from '@/modules/_global/variables/rules';
import formEditable, { CREATE } from '@/modules/_global/mixins/form-editable';
import BookingResourceSheet from '../BookingResourceSheet.vue';
import CustomerSelect from '@/modules/booking_reservations/components/CustomerSelect';

export default {
  name: 'BookingReservationForm',

  filters: {
    dateFormat
  },

  components: {
    CustomerSelect,
    BookingResourceSheet,
    BookingReservationDayForm: () => import('./BookingReservationDayForm.vue'),
    BookingReservationHourForm: () => import('./BookingReservationHourForm.vue')
  },

  mixins: [formEditable],

  props: {
    resource: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      form: {
        person_id: null,
        created_at: null,
        person: {
          full_name: null
        }
      },
      rules: {
        person_id: [notEmpty],
        info: [maxLength(400)],
        number_of_visitors: [isNumeric]
      },
      customer: null
    };
  },

  computed: {
    ...mapGetters(['loading']),
    isCreate() {
      return this.action === CREATE;
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.customer = (this.form.person && this.form.person.full_name) || null;
    });
  },

  methods: {
    getComponentByType(type) {
      switch (type) {
        case DAY:
          return 'BookingReservationDayForm';
        case HOUR:
          return 'BookingReservationHourForm';
        case MINUTE:
          return 'BookingReservationHourForm';

        default:
          throw new Error('Undefined type!');
      }
    }
  }
};
</script>
